export default "__VITE_ASSET__CdVVdU9T__"